/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import pluralize from 'utils/pluralize';

export const stringifyEntityCounts = ({ fileCount, folderCount, subfolderCount = 0 }) => {
  let text = '';

  if (folderCount > 0) {
    text += folderCount + ' ' + pluralize('folder', folderCount);

    if ((subfolderCount > 0 && fileCount === 0) || (subfolderCount === 0 && fileCount > 0)) {
      text += ' and ';
    } else if (subfolderCount > 0 && fileCount > 0) {
      text += ', ';
    }
  }

  if (subfolderCount > 0) {
    text += subfolderCount + ' ' + pluralize('subfolder', subfolderCount);

    if (fileCount > 0) {
      text += ', and ';
    }
  }

  if (fileCount > 0) {
    text += fileCount + ' ' + pluralize('file', fileCount);
  }

  return text;
};
